import React from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";

import {SetQuestionPracticeSkillsUpdatedAction} from "../../actions/question_actions";

function GradingMode({question}) {
    const dispatch = useDispatch();
    const question_practice_skills_updated = useSelector(state => state.question_practice_skills_updated);
    const selected_assignment_index = useSelector(state => state.selected_assignment_index);
    const question_practice_skill_updated = question_practice_skills_updated[selected_assignment_index];

    function updateGradingMode(mode) {
        const question_practice_skills_updated_x = JSON.parse(JSON.stringify(question_practice_skills_updated));
        question_practice_skills_updated_x[selected_assignment_index].mode = mode;
        if (mode === 'correct_answer') {
            question_practice_skills_updated_x[selected_assignment_index].grading_instructions = null;
            question_practice_skills_updated_x[selected_assignment_index].questions = null;
        } else if (mode === 'attempt') {
            question_practice_skills_updated_x[selected_assignment_index].grading_instructions = null;
            question_practice_skills_updated_x[selected_assignment_index].questions = null;
            question_practice_skills_updated_x[selected_assignment_index].correct_answer = null;
        } else if (mode === 'ai') {
            question_practice_skills_updated_x[selected_assignment_index].grading_instructions = Array(question_practice_skills_updated_x[selected_assignment_index].max_points + 1).fill("");
            question_practice_skills_updated_x[selected_assignment_index].correct_answer = null;
        }
        dispatch(SetQuestionPracticeSkillsUpdatedAction(question_practice_skills_updated_x));
    }

    function renderOptions() {
        const options = [];
        options.push(<option key='none' value=''>Please select</option>);
        options.push(<option key='ai' value='ai'>Grade with AI</option>);
        if ([
            'answer.choice_single',
            'answer.choice_multiple',
            'poll.inline',
            'answer.slider',
            'answer.range',
            'answer.number_line',
            'answer.dnd',
            'answer.selector',
            'answer.matching',
            'answer.fraction',
            'answer.number_only',
            'answer.dnd_puzzle'
        ].includes(question.answer_type)) {
            options.push(<option key='correct_answer' value='correct_answer'>Grade by Correct Answer</option>);
        }
        options.push(<option key='attempt' value='attempt'>Grade by attempt</option>);

        return options;
    }

    return (
        <div className='col-sm-4'>
            <label className='form-label'>Grading Mode</label>
            <div>
                <select
                    value={question_practice_skill_updated && question_practice_skill_updated.mode ? question_practice_skill_updated.mode : ''}
                    onChange={event => updateGradingMode(event.target.value)}
                >
                    {renderOptions()}
                </select>
            </div>
        </div>
    );
}

GradingMode.propTypes = {
    question: PropTypes.shape({
        answer_type: PropTypes.string.isRequired
    }).isRequired
}

export default GradingMode;
